<script type="text/javascript">
import { mapState } from 'vuex';
import whatIsNewFlowVersion1Footer from './flows/what-is-new-flow-version-1/what-is-new-flow-version-1-footer.vue';
import { VERSION_TO_MIGRATE_TO } from './helpers';

export default {
  components: {
    whatIsNewFlowVersion1Footer,
  },
  computed: {
    ...mapState('profile', ['settings']),
    currentFlow() {
      if (VERSION_TO_MIGRATE_TO === 1) {
        return 'whatIsNewFlowVersion1Footer';
      }
      return null;
    },
  },
};
</script>

<template>
  <div class="what-is-new-popup-footer">
    <component :is="currentFlow" />
  </div>
</template>



// WEBPACK FOOTER //
// src/components/what-is-new-popup/what-is-new-popup-footer.vue